<script lang="ts">
  import type { TicketEvent } from "../../../types/ticket";
  import MessageInner from "./MessageInner.svelte";

  export let s;
  export let marginTop;
  export let ticketEvent: TicketEvent;
  export let agentName;
  export let language;
</script>

<div style={`margin-top: ${marginTop}`}>
  <div>
    <div class={s.agentName}>
      {agentName}
    </div>
  </div>
  <MessageInner
    {s}
    overrideStyle="margin-left: 0 !important;"
    text={(ticketEvent.payload.translations || {})[language] ||
      ticketEvent.payload.text}
  />
</div>
